import React from "react";
import { useParams } from "react-router-dom";
import { ResetPassword } from "../containers";

export default function ResetPasswordPage() {
    const { id } = useParams();
    if (id) {
        return <ResetPassword token={id} />;
    }
    return null;
};
